import React, { createContext, ReactNode, useContext, useState } from 'react';

type EquipesContextType = { showToast: boolean; handleShowToast: () => void };

type EquipesProviderProps = {
  children: ReactNode;
};

const EquipesContext = createContext<EquipesContextType | null>(null);

export const EquipesContextProvider = ({ children }: EquipesProviderProps) => {
  const [showToast, setShowToast] = useState(false);

  const handleShowToast = () => {
    setShowToast(true);

    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  return (
    <EquipesContext.Provider value={{ showToast, handleShowToast }}>
      {children}
    </EquipesContext.Provider>
  );
};

export const useEquipesContext = () => {
  return useContext(EquipesContext);
};
